import { useEffect, useState } from 'react';
import { useFlag } from '@unleash/proxy-client-react';

import { FeatureFlag } from 'utils/enums';
import { local, LOCAL_KEYS } from 'utils/storage';

export const useDarkTheme = () => {
  const isEnabledDarkMode = useFlag(FeatureFlag.DarkMode);
  const initialTheme =
    isEnabledDarkMode &&
    (local.get(LOCAL_KEYS.THEME) === 'dark' ||
      window.matchMedia('(prefers-color-scheme: dark)').matches)
      ? 'dark'
      : 'light';

  const [theme, setTheme] = useState<'dark' | 'light'>(initialTheme);

  const toggleTheme = () => {
    if (!isEnabledDarkMode) return;
    setTheme((prevTheme) => (prevTheme === 'light' ? 'dark' : 'light'));
  };

  useEffect(() => {
    local.set(LOCAL_KEYS.THEME, theme);
    document.documentElement.classList.toggle('dark', theme === 'dark');
  }, [theme]);

  return { theme, toggleTheme };
};
